import type { ITooProcedureCustomControlData } from '../validation/customControls/ophthalmology';

export function tooV1ProcedureInitializeCustomControlData(): ITooProcedureCustomControlData {
    return {
        aanvullend_onderzoek: [],
        aanvullend_onderzoek_od: [],
        aanvullend_onderzoek_os: [],
        algemene_gezondheid_en_medicatie: null,
        amsler_test_od: null,
        amsler_test_os: null,
        autorefractie_as_od: null,
        autorefractie_as_os: null,
        autorefractie_cylindrisch_od: null,
        autorefractie_cylindrisch_os: null,
        autorefractie_sferisch_od: null,
        autorefractie_sferisch_os: null,
        break_up_time_od: null,
        break_up_time_os: null,
        cycloplegische_as_od: null,
        cycloplegische_as_os: null,
        cycloplegische_cylindrisch_od: null,
        cycloplegische_cylindrisch_os: null,
        cycloplegische_sferisch_od: null,
        cycloplegische_sferisch_os: null,
        draagt_correctie: null,
        eigen_correctie_as_od: null,
        eigen_correctie_as_os: null,
        eigen_correctie_cylindrish_od: null,
        eigen_correctie_cylindrish_os: null,
        eigen_correctie_sferisch_od: null,
        eigen_correctie_sferisch_os: null,
        ervaart_klachten_als_storend: null,
        familiaire_voorgeschiedenis: null,
        files: [],
        gonioscopie_od: null,
        gonioscopie_os: null,
        gonioscopie_toelichting_od: null,
        gonioscopie_toelichting_os: null,
        huisarts_betrokkenheid: null,
        huisarts_is_betrokken: null,
        isPatientInformed: false,
        klachten: null,
        nabije_visus_od: null,
        nabije_visus_os: null,
        oculaire_voorgeschiedenis: null,
        oogdruk_od: null,
        oogdruk_os: null,
        pachymetrie_od: null,
        pachymetrie_os: null,
        protocol: null,
        reden_van_bezoek: null,
        reden_van_bezoek_overig: null,
        refractie_as_od: null,
        refractie_as_os: null,
        refractie_cylindrish_od: null,
        refractie_cylindrish_os: null,
        refractie_sferisch_od: null,
        refractie_sferisch_os: null,
        rijdt_auto: null,
        stenopeische_visus_od: null,
        stenopeische_visus_os: null,
        verwijsbrief_beschikbaar: null,
        verwijzer: null,
        verwijzer_overig: null,
        visus_od: null,
        visus_os: null,
        visus_refractie_od: null,
        visus_refractie_os: null,
    };
}
